<template>
  <div class="px-2 mb-4">
    <div
      class="w-full mx-2 bg-white rounded-lg shadow-xl border-b-8 border-gray-700 rounded-lg relative"
    >
      <div class="w-96 rounded-lg px-4 pt-2 flex h-64">
        <!-- <div class="w-1/3 pt-6 flex justify-center"> -->
        <!-- <img class="w-16 h-16 bg-gray-700 text-white p-3 rounded-full" /> -->
        <!-- </div> -->
        <div class="w-full pt-9 pr-4">
          <span class="text-2xl font-bold text-gray-800">{{
            product.title
          }}</span>
          <hr />
          <p class="text-xl py-4 text-sm text-gray-700">
            {{ product.short_description }}
          </p>
        </div>
      </div>

      <div class="absolute bottom-0 w-full mb-2 px-4 flex space-x-4">
        <button
          @click="deleteProduct"
          class="w-1/2 px-4 py-3 text-center bg-red-700 text-white hover:bg-red-900 hover:text-white font-bold rounded-lg text-sm"
        >
          <fa-icon :icon="['fas', 'trash']" size="lg" />
        </button>
        <button
          @click="goToProductEdit"
          class="w-1/2 px-4 py-3 text-center text-pink-100 bg-gray-700 rounded-lg hover:bg-gray-600 hover:text-white font-bold text-sm"
        >
          <fa-icon :icon="['fas', 'pen']" size="lg" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    deleteProduct() {
      this.$emit('delete-product', this.product)
    },
    goToProductEdit() {
      this.$router.push({
        name: 'CreateOrUpdateProduct',
        params: { id: this.product.id }
      })
    }
  }
}
</script>
